import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

function lazyLoad(view) {
    return () => import(`./views/${view}.vue`);
}

export default new Router({
    base: process.env.VUE_APP_PATH_PREFIX ? process.env.VUE_APP_PATH_PREFIX : '/',
    routes: [

        {
            path: '/affiliate-program',
            name: 'Affiliate',
            component: lazyLoad('affiliate-program')
        },
        {
            path: '/offers',
            name: 'Offers',
            component: lazyLoad('offers')
        },
        {
            path: '/',
            name: 'Home',
            component: lazyLoad('Home')
        },
        {
            path: '/about',
            name: 'About',
            component: lazyLoad('About')
        },
        {
            path: '/vps',
            name: 'Vps',
            component: lazyLoad('vps')
        },
        {
            path: '/managed-wordpress',
            name: 'Managedwordpress',
            component: lazyLoad('managed-wordpress')

        },
        {
            path: '/cdn',
            name: 'Cdn',
            component: lazyLoad('cdn')
        },
        {
            path: '/web-hosting',
            name: 'Webhosting',
            component: lazyLoad('web-hosting')
        },
        {
            path: '/reseller-hosting',
            name: 'Resellerhosting',
            component: lazyLoad('reseller-hosting')
        },
        {
            path: '/domain-names',
            name: 'domainnames',
            component: lazyLoad('domain-names')
        },
        {
            path: '/contact',
            name: 'contact',
            component: lazyLoad('contact')
        },
        {
            path: '/green-credentials',
            name: 'greencredentials',
            component: lazyLoad('green-credentials')
        },
        {
            path: '/free-marketing-consultation',
            name: 'MarketingConsultation',
            component: lazyLoad('free-marketing-consultation')
        },
        {
            path: '/status',
            name: 'status',
            component: lazyLoad('status')
        },
        {
            path: '/agreements',
            name: 'agreements',
            component: lazyLoad('agreements/index')
        },
        {
            path: '/agreements/cookie-policy',
            name: 'cookiepolicy',
            component: lazyLoad('agreements/cookie-policy')
        },
        {
            path: '/agreements/fair-usage-policy',
            name: 'fairusagepolicy',
            component: lazyLoad('agreements/fair-usage-policy')
        },
        {
            path: '/agreements/discount-terms-and-conditions',
            name: 'discounttermsandconditions',
            component: lazyLoad('agreements/discount-terms-and-conditions')
        },
        {
            path: '/agreements/privacy-policy',
            name: 'privacypolicy',
            component: lazyLoad('agreements/privacy-policy')
        },
        {
            path: '/agreements/security-and-data-processing',
            name: 'securityanddataprocessing',
            component: lazyLoad('agreements/security-and-data-processing')
        },
        {
            path: '/agreements/terms-and-conditions',
            name: 'termsandconditions',
            component: lazyLoad('agreements/terms-and-conditions')
        },
        {
            path: '/agreements/free-domain-terms',
            name: 'freedomainterms',
            component: lazyLoad('agreements/free-domain-terms')
        },
        {
            path: '/agreements/third-party-processors',
            name: 'thirdpartyprocessors',
            component: lazyLoad('agreements/third-party-processors')
        },
        {
            path: '/agreements/january-sale-terms',
            name: 'januarysaleterms',
            component: lazyLoad('agreements/january-sale-terms')
        },
        {
            // Default web hosting path
            path: '/order-web-hosting',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/order/hosting?signupPlan=ultimate'; }
        },
        {
            path: '/order-essential-hosting',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/order/hosting?signupPlan=essential'; }
        },
        {
            path: '/order-professional-hosting',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/order/hosting?signupPlan=professional'; }
        },
        {
            path: '/order-ultimate-hosting',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/order/hosting?signupPlan=ultimate'; }
        },
        {
            path: '/order-reseller-hosting',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/order/hosting?signupPlan=reseller'; }
        },
        {
            path: '/order-managed-wordpress-hosting',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/order/managed-wordpress-hosting'; }
        },
        {
            path: '/order-essential-vps',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/order/vps?signupPlan=essential'; }
        },
        {
            path: '/order-professional-vps',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/order/vps?signupPlan=professional'; }
        },
        {
            path: '/order-business-vps',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/order/vps?signupPlan=business'; }
        },
        {
            path: '/account',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/cp/home'; }
        },
        {
            path: '/basket',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/cp/basket'; }
        },
        {
            path: '/?page=servers',
            beforeEnter() { location.href = '//www.ecowebhosting.co.uk/vps'; }
        },
        {
            path: '/support',
            beforeEnter() { location.href = '//support.ecowebhosting.co.uk/'; }
        },

    ],

    scrollBehavior: function (to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    },
    mode: 'history'
});
